import SessionService from "../../server/session";
import { appointmentsServer } from "../../server/appointments";

const appointmentsStore = {
  namespaced: true,
  state: {
    appointments: [],
    appointmentRequests: [],
    appointmentsLoaded: false,
    upcomingAppointments: [],
    pastAppointments: [],
    nextAppointment: {
      appointmentDate: "",
      episodeOfCareId: ""
    },
    lastAppointment: {
      appointmentDate: "",
      episodeOfCareId: ""
    },
    signingUpByOther: false,
  },
  getters: {
    appointments: state => state.appointments,
    appointmentRequests: state => state.appointmentRequests,
    appointmentsLoaded: state => state.appointmentsLoaded,
    upcomingAppointments: state => state.upcomingAppointments,
    pastAppointments: state => state.pastAppointments,
    nextAppointment: state => state.nextAppointment,
    lastAppointment: state => state.lastAppointment,
    signingUpByOther: state => state.signingUpByOther
  },
  mutations: {
    setAppointments: (state, appointments) =>
      (state.appointments = appointments),
    setAppointmentRequests: (state, appointmentRequests) =>
      (state.appointmentRequests = appointmentRequests),
    setAppointmentsLoaded: (state, newState) =>
      (state.appointmentsLoaded = newState),
    setUpcomingAppointments: (state, appointments) =>
      (state.upcomingAppointments = appointments),
    setNextAppointment: (state, appointment) =>
      (state.nextAppointment = appointment),
    setPastAppointments: (state, appointments) =>
      (state.pastAppointments = appointments),
    setLastAppointment: (state, appointment) =>
      (state.lastAppointment = appointment),
    signingUpByOtherTrue: (state) =>
      (state.signingUpByOther = true),
    signingUpByOtherFalse: (state) =>
      (state.signingUpByOther = false)
  },
  actions: {
    loadAppointments({ commit, rootGetters }) {
      const currentLocationDateTime = rootGetters[
        "layout/getCurrentAdjustedDateTime"
      ]();
      if (SessionService.isLogged()) {
        appointmentsServer.getAll()
          .then(res => {
            commit("setAppointments", res.data);

            const upcoming = res.data.filter(appointment => {
              var startDate = new Date(appointment.appointmentDate);
              return (
                new Date(appointment.appointmentEndDate < appointment.appointmentDate ? startDate.setDate(startDate.getDate() + 1) : appointment.appointmentEndDate) > currentLocationDateTime
              );
            });
            commit("setUpcomingAppointments", upcoming);
            const nextUpcomingAppointment = upcoming.find(
              event => event.status === "Show"
            );
            commit(
              "setNextAppointment",
              nextUpcomingAppointment || {
                appointmentDate: ""
              }
            );
            const past = res.data
              .filter(appointment => {
                var startDate = new Date(appointment.appointmentDate);
                return (
                  new Date(appointment.appointmentEndDate < appointment.appointmentDate ? startDate.setDate(startDate.getDate() + 1) : appointment.appointmentEndDate) <=
                  currentLocationDateTime
                );
              })
              .sort((a, b) => {
                return (
                  new Date(b.appointmentDate) - new Date(a.appointmentDate)
                );
              });
            commit("setPastAppointments", past);
            if (past.length > 0) {
              commit("setLastAppointment", past[0]);
            }

            commit("setAppointmentsLoaded", true);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    async loadAppointmentRequests({ commit, rootState }) {
      if (SessionService.isLogged()) {
        appointmentsServer.getAppointmentRequests(
          rootState.session.user.Patient.Id
        )
          .then(res => {
            commit("setAppointmentRequests", res.data);
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    changeSigningUpByOtherToTrue({ commit }) {
        commit("signingUpByOtherTrue");
    },
    changeSigningUpByOtherToFalse({ commit }) {
        commit("signingUpByOtherFalse");
    }
  }
};

export default appointmentsStore;
